import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { userStore } from '../../store/UserStore';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import DashboardHttp from 'pages/profile/services/profile.service';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import SignUpService from './newsignin.service';
import api from '../../api/client';
import { useHistory } from 'react-router-dom';
import LoginService from 'pages/login/services/login.service';

const CustomerDetails = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const [pincode, setPincode] = useState('');
  const [pincodeError, setPincodeError] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [incomeGroup, setIncomeGroup] = useState([]);
  const [incomeSource, setIncomeSource] = useState([]);
  const [user, setUser] = userStore((state: any) => [
    state.user,
    state.setUser,
  ]);

  const [isInvalidRC, setIsInvalidRC] = useState(false);
  const [invalidRC, setInvalidRC] = useState('');
  const [busPartName, setBusPartName] = useState('');
  const [referralCode, setReferralCode] = useState('');

  const history = useHistory();

  const token = api.getToken();

  const userSchema = Yup.object().shape({
    displayName: Yup.string().required('Display Name is required'),

    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),

    // dob: Yup.date().required('Date of Birth is required'),

    // gender: Yup.string()
    //   .oneOf(['M', 'F'], 'Invalid gender selection')
    //   .required('Gender is required'),

    // incomeSource: Yup.string().required('Income Source is required'),

    // incomeGroup: Yup.string().required('Annual Income is required'),

    pincode: Yup.string()
      .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits')
      .required('Pincode is required'),

    referralCode: Yup.string(), // optional, no .required()

    consent: Yup.boolean().oneOf(
      [true],
      'You must accept the terms and conditions'
    ),
  });

  const getIncomeGroupAndSource = async () => {
    try {
      // Fetch data in parallel
      const [incomeGroupResponse, incomeSourceResponse] = await Promise.all([
        DashboardHttp.getIncomeGroup(),
        DashboardHttp.getIncomeSource(),
      ]);

      if (
        incomeGroupResponse.status === 200 &&
        incomeGroupResponse.data?.data
      ) {
        setIncomeGroup(incomeGroupResponse.data.data);
      }

      if (
        incomeSourceResponse.status === 200 &&
        incomeSourceResponse.data?.data
      ) {
        setIncomeSource(incomeSourceResponse.data.data);
      }
    } catch (error) {
      console.error('Error fetching income data:', error);
    } finally {
      setLoading(false); // Stop loading after data fetching is done
    }
  };

  const createIndCustomer = async (values) => {
    try {
      const customer_data = {
        customerType: 'IND',
        displayName: values.displayName,
        kyc: {},
      };
      if (isInvalidRC) {
        setLoading(false);
        return toast.error(invalidRC);
      }
      if (pincodeError) {
        return;
      }
      setBtnLoading(true);
      const cus_res: any = await CustomerOnboardingHttp.createCustomer(
        customer_data,
        user?.userId
      );

      if (cus_res.status === 200 && cus_res.data) {
        const account_data = {
          customerId: cus_res.data.data.customerId,
          pinCode: pincode,
          stateName: selectedState,
        };

        // if (acc_res.status === 200 && acc_res.data) {
        const res = await SignUpService.createCustomerDetails(values, token);
        if (res.status == 200) {
          const acc_res: any = await CustomerOnboardingHttp.createAccount(
            account_data,
            user?.userId
          );
          if (acc_res.status === 200 && acc_res.data) {
            toast.success('New customer account has been created.');
            history.push('/customers');
          }
        }
      }
      setLoading(false);
    } catch (e: any) {
      toast.error(e.data.errors[0].title);
      setLoading(false);
    }
  };

  const isValidReferral = async (
    code: any,
    setFieldError: (field: string, message: string) => void,
    setFieldValue: any
  ) => {
    try {
      const res: any = await LoginService.isValidReferralCode(code);
      setReferralCode(code);
      setFieldValue(code);
      setBusPartName(res?.data?.data[0]?.businessName);
      setFieldError('referralCode', ''); // Replace 'fieldName' with the name of the field you want to set an error for
      setInvalidRC('');
      setIsInvalidRC(false);
    } catch (err) {
      console.log(err);
      setIsInvalidRC(true);
      setReferralCode(code);

      // setFieldValue(code)
      setInvalidRC('Invalid Referral Code');
      setBusPartName('');
      setFieldError('referralCode', 'Invalid Referral Code'); // Replace 'fieldName' with the name of the field you want to set an error for
    }
  };

  const checkPincode = async (pincode) => {
    if (pincode?.length === 6) {
      try {
        const response: any = await CustomerOnboardingHttp.getStatebyPincode(
          pincode
        );

        if (response.status == 200 && response.data) {
          setPincode(pincode);
          setSelectedState(response.data?.data?.stateName);
          return true;
        }
      } catch (error) {
        setPincodeError('Pincode not serviceable');
        setSelectedState('');
        return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    getIncomeGroupAndSource();
  }, []);

  useEffect(() => {
    checkPincode(pincode);
  }, [pincode]);

  return (
    <div>
      <Toast />
      <div className='row justify-content-md-center'>
        <div className='col-md-6 col-md-offset-3 mt-3'>
          <Card>
            <Card.Body className='p-5 pt-3 pb-0'>
              <div>
                <div className='text-center mb-3'>
                  <Card.Title style={{ color: '#99834d' }}>
                    Create New Customer Account
                  </Card.Title>
                  {/* <Card.Subtitle>
                    Setup your account and start your bullion journey today
                  </Card.Subtitle> */}
                </div>

                <Formik
                  enableReinitialize={false}
                  initialValues={{
                    displayName: '',
                    email: '',
                    dob: '',
                    gender: '',
                    incomeSource: '',
                    incomeGroup: '',
                    pincode: '',
                    referralCode: '',
                    consent: true, // checked by default
                  }}
                  validationSchema={userSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    createIndCustomer(values);
                    // Your API call here
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    setFieldError,
                  }) => (
                    <Form>
                      {/* Row 1: Display Name & Email */}
                      <div className='row'>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>
                            Display Name<span style={{ color: 'red' }}> *</span>
                          </label>
                          <Field
                            type='text'
                            name='displayName'
                            className='form-control'
                            placeholder='Your Name as per PAN Card'
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              const regex = /^[A-Za-z ]+$/; // Allows only letters and spaces

                              if (regex.test(value) || value === '') {
                                setFieldValue('displayName', value);
                              }
                            }}
                          />
                          {errors.displayName && touched.displayName && (
                            <div
                              className='text-danger small'
                              style={{ fontSize: '12px' }}
                            >
                              {errors.displayName}
                            </div>
                          )}
                        </div>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>
                            Email<span style={{ color: 'red' }}> *</span>
                          </label>
                          <Field
                            type='email'
                            name='email'
                            className='form-control'
                          />
                          {errors.email && touched.email && (
                            <div
                              className='text-danger small'
                              style={{ fontSize: '12px' }}
                            >
                              {errors.email}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Row 2: DOB & Gender */}
                      <div className='row'>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>DOB</label>
                          <Field
                            type='date'
                            name='dob'
                            className='form-control'
                            max={new Date().toISOString().split('T')[0]}
                          />
                          {errors.dob && touched.dob && (
                            <div className='text-danger small'>
                              {errors.dob}
                            </div>
                          )}
                        </div>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>Gender</label>
                          <Field
                            as='select'
                            name='gender'
                            className='form-control'
                          >
                            <option value=''>Select Gender</option>
                            <option value='M'>Male</option>
                            <option value='F'>Female</option>
                            <option value='O'>Other</option>
                          </Field>
                          {errors.gender && touched.gender && (
                            <div className='text-danger small'>
                              {errors.gender}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Row 3: Annual Income & Income Source */}
                      <div className='row'>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>Annual Income</label>
                          <Field
                            as='select'
                            name='incomeGroup'
                            className='form-control'
                          >
                            <option value=''>Select</option>
                            {incomeGroup?.map((item: any) => (
                              <option key={item.id} value={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </Field>
                          {errors.incomeGroup && touched.incomeGroup && (
                            <div className='text-danger small'>
                              {errors.incomeGroup}
                            </div>
                          )}
                        </div>

                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>Income Source</label>
                          <Field
                            as='select'
                            name='incomeSource'
                            className='form-control'
                          >
                            <option value=''>Select</option>
                            {incomeSource?.map((item: any) => (
                              <option key={item.id} value={item.id}>
                                {item.title}
                              </option>
                            ))}
                          </Field>
                          {errors.incomeSource && touched.incomeSource && (
                            <div className='text-danger small'>
                              {errors.incomeSource}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Row 4: Pincode & State */}
                      <div className='row'>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>
                            Pincode<span style={{ color: 'red' }}> *</span>
                          </label>
                          <Field
                            type='text'
                            name='pincode'
                            className='form-control'
                            onChange={(e: any) => {
                              const value = e.target.value.replace(/\D/g, ''); // allow only numbers
                              if (value.length <= 6) {
                                setFieldValue('pincode', value);
                                setPincode(value);
                                setPincodeError('');
                              }
                            }}
                            value={values.pincode}
                            maxLength={6}
                          />
                          {errors.pincode && touched.pincode && (
                            <div
                              className='text-danger '
                              style={{ fontSize: '12px' }}
                            >
                              {errors.pincode}
                            </div>
                          )}
                          {pincodeError && (
                            <div
                              className='text-danger '
                              style={{ fontSize: '12px' }}
                            >
                              {pincodeError}
                            </div>
                          )}
                        </div>

                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>State</label>
                          <Field
                            type='text'
                            className='form-control'
                            disabled
                            value={selectedState} // from your external state
                          />
                        </div>
                      </div>

                      {/* Referral Code */}
                      <div className='row'>
                        <div className='form-group col-md-6 mb-2'>
                          <label className='form-label'>
                            Referral Code (Optional)
                          </label>
                          <Field
                            type='text'
                            name='referralCode'
                            className='form-control'
                            placeholder='Referral Code'
                            onChange={async (e: any) => {
                              setReferralCode(e.target.value);
                              setInvalidRC('');
                              setIsInvalidRC(false);
                              setFieldValue('referralCode', e.target.value);
                              if (e.target.value !== '') {
                                isValidReferral(
                                  e.target.value,
                                  setFieldError,
                                  setFieldValue
                                );
                              }
                            }}
                            value={referralCode}
                            maxLength={12}
                          />
                          {busPartName && (
                            <div className='text-success small mt-1'>
                              Referral from: <strong>{busPartName}</strong>
                            </div>
                          )}

                          {errors.referralCode && touched.referralCode && (
                            <div className='text-danger small'>
                              {errors.referralCode}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Consent */}
                      <div className='form-group  mb-2 d-flex align-items-center mt-1'>
                        <Field
                          type='checkbox'
                          name='consent'
                          className='me-2'
                          checked={values.consent}
                        />
                        <label className='form-label mb-0'>
                          I Agree to the{' '}
                          <a
                            href='https://ebullion.in/terms-and-conditions/T&C.html'
                            target='_blank'
                            rel='noreferrer'
                            style={{ color: '#99834d' }}
                          >
                            terms and conditions
                          </a>{' '}
                        </label>
                      </div>
                      {errors.consent && touched.consent && (
                        <div
                          className='text-danger small'
                          style={{ fontSize: '12px' }}
                        >
                          {errors.consent}
                        </div>
                      )}

                      {/* Submit Button */}
                      <div className='form-group mt-4'>
                        <Button
                          variant='primary'
                          className='w-100 mb-3'
                          size='lg'
                          type='submit'
                        >
                          {!btnLoading ? (
                            'Create Customer'
                          ) : (
                            <div
                              className='spinner-border text-white'
                              role='status'
                            >
                              <span className='visually-hidden'>
                                Loading...
                              </span>
                            </div>
                          )}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
